const fromAnyToLowerCase = (any) => (any === null || undefined === any ? '' : String(any)).toLowerCase();

// noinspection JSUnusedGlobalSymbols
export default fromAnyToLowerCase;
